import { FC, useEffect } from 'react';
import { $generateNodesFromDOM } from '@lexical/html';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $getRoot, $insertNodes } from 'lexical';

export const ImportPlugin: FC<{
    defaultContentAsHTML?: string;
    defaultContentAsJSON?: string;
}> = ({
    defaultContentAsHTML,
    defaultContentAsJSON
}) => {
    const [editor] = useLexicalComposerContext();

    useEffect(() => {
        if (typeof defaultContentAsHTML === 'undefined') return;
        editor.update(() => {
            const parser = new DOMParser();
            const textHtmlMimeType: DOMParserSupportedType = 'text/html';
            const dom = parser.parseFromString(defaultContentAsHTML, textHtmlMimeType);
            const nodes = $generateNodesFromDOM(editor, dom);
            $getRoot().select();
            $insertNodes(nodes);
        });
    }, [editor, defaultContentAsHTML]);

    useEffect(() => {
        if (typeof defaultContentAsJSON === 'undefined') return;
        setTimeout(() => {
            editor.update(() => {
                const editorState = editor.parseEditorState(defaultContentAsJSON);
                editor.setEditorState(editorState);
            });
        }, 0);
    }, [editor, defaultContentAsJSON]);

    return null;
};

export default ImportPlugin;
